export function register(req) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      device_type: localStorage.getItem("deviceType"),
    },
    body: JSON.stringify(req),
  };
  console.log("POST Login", requestOptions);
  return fetch("/shared/api/auth/register", requestOptions).then((response) =>
    response.json()
  );
}
